import React from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from "@ant-design/icons";
import { useAuthStore } from "../../../../store/auth/auth";
import { DeleteDevice } from "../../../../api/devices/deleteDevice";
import { Key } from "antd/lib/table/interface";
import { useButtonsFromAllcams } from "../../../../store/devices/useButtonsFromAllcams";
import { DeleteUser } from "../../../../api/users/deleteUsers";
import "./styleDeleteUser.css"

interface DeleteDeviceProps {
    open: boolean;
    users: Key[];
    onOk: () => void;
    onCancel: () => void;
}
const DeleteUserModal: React.FC<DeleteDeviceProps> = ({ open, users, onOk, onCancel }) => {

    const { user, SmartDVRToken } = useAuthStore();
    //const {setIsDeleteDeviceModal} = useButtonsFromAllcams();

    const handleOk = async () => {
        if (users && SmartDVRToken && user) {
            try {
                for (const uid of users) {
                    const usersData = { uid };
                    const response = await DeleteUser(SmartDVRToken, user.login, usersData as any);
                    if (!response.success) {
                        console.error('Error deleting user:', response.error);
                    }
                }
                onOk(); // Закрыть модальное после всех итераций
            } catch (error) {
                console.error('Error deleting user:', error);
            }
        } else {
            console.warn('data is missing');
        }
    };

    const handleOnCancel = () => {
        onCancel()
    }

    return (
        <Modal
            title={
                <div className="titleUser">
                    <span className="spanUser">Удаление пользователей</span>
                    <CloseOutlined onClick={onCancel} className="closeBut_User" />
                </div>
            }
            className="deleteUser_modal"
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            closable={false}
            footer={
                <>
                    <Button className="buttonYes" onClick={handleOnCancel}>Нет</Button>
                    <Button className="buttonNo" onClick={handleOk}>Да</Button>
                </>
            }
        >
            <span> Удалить {users.length} пользователя? </span>

        </Modal>
    );
};
export default DeleteUserModal;